/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { useTranslation } from "react-i18next";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import world from "../assets/whyus/world.svg";
import worldJp from "../assets/whyus/world-jp.jpg";
import edit from "../assets/whyus/edit.svg";
import image from "../assets/whyus/image.svg";
const data = [
  {
    title: "why_us_1",
    des: "why_us_1_des",
    icon: world,
    icon_ja: worldJp,
  },
  {
    title: "why_us_2",
    des: "why_us_2_des",
    icon: edit,
    icon_ja: edit,
  },
  {
    title: "why_us_3",
    des: "why_us_3_des",
    icon: image,
    icon_ja: image,
  },
];
export const WhyUs = (props) => {
  const { t, i18n } = useTranslation();
  const currentLangue = i18n.language;
  return (
    <section id="why_us">
      <div className="contInner">
        <h2 className="hdg_ttl02">
          <div>
            <span>
              {t(`why_us_title`)}
              <span className="c">{t(`why_us_ai-prop`)}</span>
            </span>
          </div>
        </h2>
        <div className="swiperWrap">
          <Swiper
            className="swiper01"
            modules={[Navigation]}
            loop={true}
            slidesPerView={1}
            // spaceBetween={35}
            breakpoints={{
              768: {
                slidesPerView: 1, // Adjusted for tablet view
              },
              810: {
                slidesPerView: 1, // Adjusted for tablet view
              },
              1024: {
                enabled: false,
                slidesPerView: 3, // Desktop view
              },
            }}
            navigation={{
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            }}
          >
            {data.map((item, index) => {
              return (
                <SwiperSlide key={index}>
                  <div className={"item i0" + (index + 1)}>
                    <svg
                      className="bg"
                      xmlns="http://www.w3.org/2000/svg"
                      width="280"
                      height="250"
                      viewBox="0 0 280 250"
                    >
                      <g
                        transform="translate(-3 -3)"
                        fill="#fff"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path
                          d="M 205.5585327148438 251.5 L 80.44092559814453 251.5 C 78.09821319580078 251.5 75.78717803955078 250.8718566894531 73.75775146484375 249.6834716796875 C 71.72525024414062 248.4933166503906 70.0303955078125 246.773681640625 68.85639190673828 244.7104644775391 L 6.297106742858887 134.8056488037109 C 5.121463775634766 132.7398529052734 4.499999523162842 130.3864593505859 4.499999523162842 128 C 4.499999523162842 125.6135711669922 5.121463775634766 123.2601776123047 6.297178268432617 121.1942825317383 L 68.85628509521484 11.28971385955811 C 70.03042602539062 9.226571083068848 71.72531890869141 7.506999969482422 73.75778198242188 6.31678581237793 C 75.787353515625 5.128250122070312 78.09835815429688 4.5 80.44092559814453 4.5 L 205.5585327148438 4.5 C 207.9011077880859 4.5 210.2121124267578 5.128250122070312 212.2417144775391 6.31678581237793 C 214.2741851806641 7.506999969482422 215.9690399169922 9.226571083068848 217.1431121826172 11.28960704803467 L 279.7023315429688 121.1943893432617 C 280.8783874511719 123.2602844238281 281.5000305175781 125.6136093139648 281.5000305175781 128 C 281.5000305175781 130.3863983154297 280.8783874511719 132.7397155761719 279.7023620605469 134.8056030273438 L 217.1431732177734 244.7102813720703 C 215.9690704345703 246.773681640625 214.2742462158203 248.4933166503906 212.2417449951172 249.6834716796875 C 210.2122802734375 250.8718566894531 207.9012908935547 251.5 205.5585327148438 251.5 Z"
                          stroke="none"
                        />
                        <path
                          d="M 80.44091796875 6 C 78.36453247070312 6 76.31568908691406 6.557113647460938 74.51579284667969 7.611160278320312 C 72.71022033691406 8.668502807617188 71.20402526855469 10.19703674316406 70.159912109375 12.03173828125 L 7.600830078125 121.9361877441406 C 5.47222900390625 125.6764984130859 5.47222900390625 130.3235015869141 7.6007080078125 134.0635681152344 L 70.16011047363281 243.9686126708984 C 71.20402526855469 245.8032379150391 72.71018981933594 247.3318023681641 74.51571655273438 248.3890838623047 C 76.31546020507812 249.4429626464844 78.3643798828125 250 80.44091796875 250 L 205.5585327148438 250 C 207.6350708007812 250 209.6839904785156 249.4429626464844 211.4837646484375 248.3890838623047 C 213.289306640625 247.3318023681641 214.79541015625 245.8032379150391 215.8395385742188 243.9682312011719 L 278.3987731933594 134.0635070800781 C 280.5278625488281 130.3233947753906 280.5278625488281 125.6766204833984 278.398681640625 121.9364166259766 L 215.8394165039062 12.031494140625 C 214.79541015625 10.19703674316406 213.2892150878906 8.668502807617188 211.4836730957031 7.611160278320312 C 209.6838073730469 6.557113647460938 207.6349182128906 6 205.5585327148438 6 L 80.44091796875 6 M 80.44091796875 3 L 205.5585327148438 3 C 210.8753051757812 3 215.7887573242188 5.877151489257812 218.4467620849609 10.54765319824219 L 281.0059204101562 120.4523468017578 C 283.6646728515625 125.1228485107422 283.6646728515625 130.8771514892578 281.0059204101562 135.5476531982422 L 218.4467620849609 245.4523010253906 C 215.7887573242188 250.1235809326172 210.8753051757812 253 205.5585327148438 253 L 80.44091796875 253 C 75.1241455078125 253 70.21072387695312 250.1235809326172 67.55268859863281 245.4523010253906 L 4.993499755859375 135.5476531982422 C 2.335479736328125 130.8771514892578 2.335479736328125 125.1228485107422 4.993499755859375 120.4523468017578 L 67.55268859863281 10.54765319824219 C 70.21072387695312 5.877151489257812 75.1241455078125 3 80.44091796875 3 Z"
                          stroke="none"
                          fill="#3963b7"
                        />
                      </g>
                    </svg>
                    <div className="inner">
                      <div className="txt01">
                        <span>
                          {t(item.title)
                            .split("\n")
                            .map((line, ind) => (
                              <React.Fragment key={ind}>
                                {line}
                                <br />
                              </React.Fragment>
                            ))}
                        </span>
                      </div>
                      <div className="icon">
                        <img
                          alt=""
                          src={
                            currentLangue === "ja" ? item.icon_ja : item.icon
                          }
                        />
                      </div>
                    </div>
                    <div className="txt02">
                      <span>{t(item.des)}</span>
                    </div>
                  </div>
                </SwiperSlide>
              );
            })}
            <div className="swiper-button-prev"></div>
            <div className="swiper-button-next"></div>
          </Swiper>
        </div>
      </div>
    </section>
  );
};
